import React from "react";
import { Helmet } from "react-helmet";
import { buildWantAdSeo } from "../helpers/seo";

const SeoHead = ({ adDetails }) => {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const pathname = typeof window !== "undefined" ? window.location.pathname : "";
  const seo = buildWantAdSeo(adDetails, { origin, pathname });

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {seo.robots ? <meta name="robots" content={seo.robots} /> : null}
      {seo.canonical ? <link rel="canonical" href={seo.canonical} /> : null}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      {seo.canonical ? (
        <meta property="og:url" content={seo.canonical} />
      ) : null}
      {seo.ogImage ? <meta property="og:image" content={seo.ogImage} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
    </Helmet>
  );
};

export default SeoHead;
